import * as _4 from 'lodash4';
export class PhoneNumberService {
  private phoneRegex: RegExp = /\b(\+*\d{1,})*([ |\(.-])*(\d{3})[^\d]*(\d{3})[^\d]*(\d{4})\b/g;
  private digits: RegExp = /\d/g;

  isValidPhoneNumber(phoneNum: string): boolean {
    return (
      !_4.isEmpty(phoneNum) &&
      !_4.isNull(phoneNum.match(this.phoneRegex)) &&
      _4.inRange(phoneNum.match(this.digits)!.length, 10, 12)
    );
  }

  sanitizePhoneNumber(phoneNum: string): string | boolean {
    if (_4.isEmpty(phoneNum)) {
      return false;
    }

    let sanitizedNum = !_4.isNull(phoneNum.match(this.digits))
      ? phoneNum.match(this.digits)!.splice(0, 11).join('')
      : '';
    if (sanitizedNum.length === 10) {
      sanitizedNum = `1${sanitizedNum}`;
    }
    return sanitizedNum;
  }
  getDisplayNumber(uglyPhoneNum: string): string {
    if (_4.isUndefined(uglyPhoneNum)) {
      return uglyPhoneNum;
    }

    if (!this.sanitizePhoneNumber(uglyPhoneNum)) {
      return uglyPhoneNum;
    }

    uglyPhoneNum = this.sanitizePhoneNumber(uglyPhoneNum) as string;

    return `(${uglyPhoneNum.slice(1, 4)}) ${uglyPhoneNum.slice(4, 7)}-${uglyPhoneNum.slice(7, 11)}`;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/services/phone_number_service.ts